import { ReservationOrder } from '../models/reservation.model';

export class OpenReservation {
  static readonly type = '[Reservation] Open Reservation';
  constructor(public order: ReservationOrder) {}
}
